// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Formality__ReactUpdate from "../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as MobileNumberValidation from "../../../../../library/work-space/form/MobileNumberValidation.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

var validators_blacklist_reason = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, param$1) {
      var blacklist_reason = param.blacklist_reason;
      if (param.temporarily_deactivated === "true") {
        if (blacklist_reason !== "-1") {
          return {
                  TAG: /* Ok */0,
                  _0: blacklist_reason
                };
        } else {
          return {
                  TAG: /* Error */1,
                  _0: "Please select a blacklist reason!"
                };
        }
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_gst_reg_address = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, param$1) {
      var gst_reg_address = param.gst_reg_address;
      if (gst_reg_address.length !== 0) {
        return {
                TAG: /* Ok */0,
                _0: gst_reg_address
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_gstin = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, param$1) {
      var gstin = param.gstin;
      if (gstin.length !== 0) {
        return {
                TAG: /* Ok */0,
                _0: gstin
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_unconfirmed_email = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, param$1) {
      var unconfirmed_email = param.unconfirmed_email;
      if (unconfirmed_email.length === 0) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var error = FormValidationUtils$Catalyst.validateEmail(unconfirmed_email);
      if (error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: error._0
              };
      }
    })
};

var validators_geo_region = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, param$1) {
      var geo_region = param.geo_region;
      if (geo_region === "-1") {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: geo_region
              };
      }
    })
};

var validators_company_name = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var company_name = param.company_name;
      if (/^[a-zA-Z0-9 _-]*$/.test(company_name)) {
        return {
                TAG: /* Ok */0,
                _0: company_name
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Only alphanumeric characters allowed."
              };
      }
    })
};

var validators_secondary_mobile = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, metadata) {
      var secondary_mobile = param.secondary_mobile;
      if (secondary_mobile.length === 0) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var error = MobileNumberValidation.execute(secondary_mobile, metadata.country);
      if (error.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: error._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: error._0
              };
      }
    })
};

var validators_last_name = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var last_name = param.last_name;
      if (/^[a-zA-Z0-9 ]{1,}$/.test(last_name)) {
        return {
                TAG: /* Ok */0,
                _0: last_name
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Only alphanumeric characters allowed."
              };
      }
    })
};

var validators_first_name = {
  strategy: /* OnSubmit */4,
  validate: (function (param, param$1) {
      var first_name = param.first_name;
      if (/^[a-zA-Z0-9 ]{1,}$/.test(first_name)) {
        return {
                TAG: /* Ok */0,
                _0: first_name
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Only alphanumeric characters allowed."
              };
      }
    })
};

var validators = {
  subscribed_for_promo_sms: undefined,
  partload_customer: undefined,
  registration_status: undefined,
  blacklist_reason: validators_blacklist_reason,
  temporarily_deactivated: undefined,
  customer_type: undefined,
  gst_reg_address: validators_gst_reg_address,
  gstin: validators_gstin,
  otp: undefined,
  email: undefined,
  unconfirmed_email: validators_unconfirmed_email,
  geo_region: validators_geo_region,
  port_gold_status: undefined,
  company_name: validators_company_name,
  secondary_mobile: validators_secondary_mobile,
  mobile: undefined,
  caller_type: undefined,
  last_name: validators_last_name,
  first_name: validators_first_name
};

function initialFieldsStatuses(_input) {
  return {
          subscribed_for_promo_sms: /* Pristine */0,
          partload_customer: /* Pristine */0,
          registration_status: /* Pristine */0,
          blacklist_reason: /* Pristine */0,
          temporarily_deactivated: /* Pristine */0,
          customer_type: /* Pristine */0,
          gst_reg_address: /* Pristine */0,
          gstin: /* Pristine */0,
          otp: /* Pristine */0,
          email: /* Pristine */0,
          unconfirmed_email: /* Pristine */0,
          geo_region: /* Pristine */0,
          port_gold_status: /* Pristine */0,
          company_name: /* Pristine */0,
          secondary_mobile: /* Pristine */0,
          mobile: /* Pristine */0,
          caller_type: /* Pristine */0,
          last_name: /* Pristine */0,
          first_name: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.subscribed_for_promo_sms
  };
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.partload_customer
  };
  var match_0$2 = {
    TAG: /* Ok */0,
    _0: input.registration_status
  };
  var match = fieldsStatuses.blacklist_reason;
  var match_0$3 = match ? match._0 : Curry._2(validators.blacklist_reason.validate, input, metadata);
  var match_0$4 = {
    TAG: /* Ok */0,
    _0: input.temporarily_deactivated
  };
  var match_0$5 = {
    TAG: /* Ok */0,
    _0: input.customer_type
  };
  var match$1 = fieldsStatuses.gst_reg_address;
  var match_0$6 = match$1 ? match$1._0 : Curry._2(validators.gst_reg_address.validate, input, metadata);
  var match$2 = fieldsStatuses.gstin;
  var match_0$7 = match$2 ? match$2._0 : Curry._2(validators.gstin.validate, input, metadata);
  var match_0$8 = {
    TAG: /* Ok */0,
    _0: input.otp
  };
  var match_0$9 = {
    TAG: /* Ok */0,
    _0: input.email
  };
  var match$3 = fieldsStatuses.unconfirmed_email;
  var match_0$10 = match$3 ? match$3._0 : Curry._2(validators.unconfirmed_email.validate, input, metadata);
  var match$4 = fieldsStatuses.geo_region;
  var match_0$11 = match$4 ? match$4._0 : Curry._2(validators.geo_region.validate, input, metadata);
  var match_0$12 = {
    TAG: /* Ok */0,
    _0: input.port_gold_status
  };
  var match$5 = fieldsStatuses.company_name;
  var match_0$13 = match$5 ? match$5._0 : Curry._2(validators.company_name.validate, input, metadata);
  var match$6 = fieldsStatuses.secondary_mobile;
  var match_0$14 = match$6 ? match$6._0 : Curry._2(validators.secondary_mobile.validate, input, metadata);
  var match_0$15 = {
    TAG: /* Ok */0,
    _0: input.mobile
  };
  var match_0$16 = {
    TAG: /* Ok */0,
    _0: input.caller_type
  };
  var match$7 = fieldsStatuses.last_name;
  var match_0$17 = match$7 ? match$7._0 : Curry._2(validators.last_name.validate, input, metadata);
  var match$8 = fieldsStatuses.first_name;
  var match_0$18 = match$8 ? match$8._0 : Curry._2(validators.first_name.validate, input, metadata);
  var subscribed_for_promo_smsResult = match_0;
  var subscribed_for_promo_smsResult$1;
  if (subscribed_for_promo_smsResult.TAG === /* Ok */0) {
    var partload_customerResult = match_0$1;
    if (partload_customerResult.TAG === /* Ok */0) {
      var registration_statusResult = match_0$2;
      if (registration_statusResult.TAG === /* Ok */0) {
        var blacklist_reasonResult = match_0$3;
        if (blacklist_reasonResult.TAG === /* Ok */0) {
          var temporarily_deactivatedResult = match_0$4;
          if (temporarily_deactivatedResult.TAG === /* Ok */0) {
            var customer_typeResult = match_0$5;
            if (customer_typeResult.TAG === /* Ok */0) {
              var gst_reg_addressResult = match_0$6;
              if (gst_reg_addressResult.TAG === /* Ok */0) {
                var gstinResult = match_0$7;
                if (gstinResult.TAG === /* Ok */0) {
                  var otpResult = match_0$8;
                  if (otpResult.TAG === /* Ok */0) {
                    var emailResult = match_0$9;
                    if (emailResult.TAG === /* Ok */0) {
                      var unconfirmed_emailResult = match_0$10;
                      if (unconfirmed_emailResult.TAG === /* Ok */0) {
                        var geo_regionResult = match_0$11;
                        if (geo_regionResult.TAG === /* Ok */0) {
                          var port_gold_statusResult = match_0$12;
                          if (port_gold_statusResult.TAG === /* Ok */0) {
                            var company_nameResult = match_0$13;
                            if (company_nameResult.TAG === /* Ok */0) {
                              var secondary_mobileResult = match_0$14;
                              if (secondary_mobileResult.TAG === /* Ok */0) {
                                var mobileResult = match_0$15;
                                if (mobileResult.TAG === /* Ok */0) {
                                  var caller_typeResult = match_0$16;
                                  if (caller_typeResult.TAG === /* Ok */0) {
                                    var last_nameResult = match_0$17;
                                    if (last_nameResult.TAG === /* Ok */0) {
                                      var first_nameResult = match_0$18;
                                      if (first_nameResult.TAG === /* Ok */0) {
                                        return {
                                                TAG: /* Valid */0,
                                                output: {
                                                  first_name: first_nameResult._0,
                                                  last_name: last_nameResult._0,
                                                  caller_type: caller_typeResult._0,
                                                  mobile: mobileResult._0,
                                                  secondary_mobile: secondary_mobileResult._0,
                                                  company_name: company_nameResult._0,
                                                  port_gold_status: port_gold_statusResult._0,
                                                  geo_region: geo_regionResult._0,
                                                  unconfirmed_email: unconfirmed_emailResult._0,
                                                  email: emailResult._0,
                                                  otp: otpResult._0,
                                                  gstin: gstinResult._0,
                                                  gst_reg_address: gst_reg_addressResult._0,
                                                  customer_type: customer_typeResult._0,
                                                  temporarily_deactivated: temporarily_deactivatedResult._0,
                                                  blacklist_reason: blacklist_reasonResult._0,
                                                  registration_status: registration_statusResult._0,
                                                  partload_customer: partload_customerResult._0,
                                                  subscribed_for_promo_sms: subscribed_for_promo_smsResult._0
                                                },
                                                fieldsStatuses: {
                                                  subscribed_for_promo_sms: /* Dirty */{
                                                    _0: subscribed_for_promo_smsResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  partload_customer: /* Dirty */{
                                                    _0: partload_customerResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  registration_status: /* Dirty */{
                                                    _0: registration_statusResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  blacklist_reason: /* Dirty */{
                                                    _0: blacklist_reasonResult,
                                                    _1: /* Shown */0
                                                  },
                                                  temporarily_deactivated: /* Dirty */{
                                                    _0: temporarily_deactivatedResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  customer_type: /* Dirty */{
                                                    _0: customer_typeResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  gst_reg_address: /* Dirty */{
                                                    _0: gst_reg_addressResult,
                                                    _1: /* Shown */0
                                                  },
                                                  gstin: /* Dirty */{
                                                    _0: gstinResult,
                                                    _1: /* Shown */0
                                                  },
                                                  otp: /* Dirty */{
                                                    _0: otpResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  email: /* Dirty */{
                                                    _0: emailResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  unconfirmed_email: /* Dirty */{
                                                    _0: unconfirmed_emailResult,
                                                    _1: /* Shown */0
                                                  },
                                                  geo_region: /* Dirty */{
                                                    _0: geo_regionResult,
                                                    _1: /* Shown */0
                                                  },
                                                  port_gold_status: /* Dirty */{
                                                    _0: port_gold_statusResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  company_name: /* Dirty */{
                                                    _0: company_nameResult,
                                                    _1: /* Shown */0
                                                  },
                                                  secondary_mobile: /* Dirty */{
                                                    _0: secondary_mobileResult,
                                                    _1: /* Shown */0
                                                  },
                                                  mobile: /* Dirty */{
                                                    _0: mobileResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  caller_type: /* Dirty */{
                                                    _0: caller_typeResult,
                                                    _1: /* Hidden */1
                                                  },
                                                  last_name: /* Dirty */{
                                                    _0: last_nameResult,
                                                    _1: /* Shown */0
                                                  },
                                                  first_name: /* Dirty */{
                                                    _0: first_nameResult,
                                                    _1: /* Shown */0
                                                  }
                                                },
                                                collectionsStatuses: undefined
                                              };
                                      }
                                      subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                                    } else {
                                      subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                                    }
                                  } else {
                                    subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                                  }
                                } else {
                                  subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                                }
                              } else {
                                subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                              }
                            } else {
                              subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                            }
                          } else {
                            subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                          }
                        } else {
                          subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                        }
                      } else {
                        subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                      }
                    } else {
                      subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                    }
                  } else {
                    subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                  }
                } else {
                  subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
                }
              } else {
                subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
              }
            } else {
              subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
            }
          } else {
            subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
          }
        } else {
          subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
        }
      } else {
        subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
      }
    } else {
      subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
    }
  } else {
    subscribed_for_promo_smsResult$1 = subscribed_for_promo_smsResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            subscribed_for_promo_sms: /* Dirty */{
              _0: subscribed_for_promo_smsResult$1,
              _1: /* Hidden */1
            },
            partload_customer: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            },
            registration_status: /* Dirty */{
              _0: match_0$2,
              _1: /* Hidden */1
            },
            blacklist_reason: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            temporarily_deactivated: /* Dirty */{
              _0: match_0$4,
              _1: /* Hidden */1
            },
            customer_type: /* Dirty */{
              _0: match_0$5,
              _1: /* Hidden */1
            },
            gst_reg_address: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            gstin: /* Dirty */{
              _0: match_0$7,
              _1: /* Shown */0
            },
            otp: /* Dirty */{
              _0: match_0$8,
              _1: /* Hidden */1
            },
            email: /* Dirty */{
              _0: match_0$9,
              _1: /* Hidden */1
            },
            unconfirmed_email: /* Dirty */{
              _0: match_0$10,
              _1: /* Shown */0
            },
            geo_region: /* Dirty */{
              _0: match_0$11,
              _1: /* Shown */0
            },
            port_gold_status: /* Dirty */{
              _0: match_0$12,
              _1: /* Hidden */1
            },
            company_name: /* Dirty */{
              _0: match_0$13,
              _1: /* Shown */0
            },
            secondary_mobile: /* Dirty */{
              _0: match_0$14,
              _1: /* Shown */0
            },
            mobile: /* Dirty */{
              _0: match_0$15,
              _1: /* Hidden */1
            },
            caller_type: /* Dirty */{
              _0: match_0$16,
              _1: /* Hidden */1
            },
            last_name: /* Dirty */{
              _0: match_0$17,
              _1: /* Shown */0
            },
            first_name: /* Dirty */{
              _0: match_0$18,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurSubscribed_for_promo_smsField */0 :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.subscribed_for_promo_sms, state.fieldsStatuses.subscribed_for_promo_sms, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: status,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPartload_customerField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.partload_customer, state.fieldsStatuses.partload_customer, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: status,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurRegistration_statusField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.registration_status, state.fieldsStatuses.registration_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurBlacklist_reasonField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.blacklist_reason, validators_blacklist_reason, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: status,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTemporarily_deactivatedField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithoutValidator(state.input.temporarily_deactivated, state.fieldsStatuses.temporarily_deactivated, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: status,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCustomer_typeField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithoutValidator(state.input.customer_type, state.fieldsStatuses.customer_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: status,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurGst_reg_addressField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.gst_reg_address, validators_gst_reg_address, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: status,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurGstinField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.gstin, validators_gstin, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: status,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurOtpField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithoutValidator(state.input.otp, state.fieldsStatuses.otp, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: status,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEmailField */9 :
                  var result$9 = Formality.validateFieldOnBlurWithoutValidator(state.input.email, state.fieldsStatuses.email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: status,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$9 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$9,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurUnconfirmed_emailField */10 :
                  var result$10 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.unconfirmed_email, validators_unconfirmed_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: status,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$10 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$10,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurGeo_regionField */11 :
                  var result$11 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.geo_region, validators_geo_region, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: status,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$11 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$11,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPort_gold_statusField */12 :
                  var result$12 = Formality.validateFieldOnBlurWithoutValidator(state.input.port_gold_status, state.fieldsStatuses.port_gold_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$12 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$12,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCompany_nameField */13 :
                  var result$13 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.company_name, validators_company_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: status,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$13 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$13,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSecondary_mobileField */14 :
                  var result$14 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.secondary_mobile, validators_secondary_mobile, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: status,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$14 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$14,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMobileField */15 :
                  var result$15 = Formality.validateFieldOnBlurWithoutValidator(state.input.mobile, state.fieldsStatuses.mobile, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: status,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$15 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$15,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCaller_typeField */16 :
                  var result$16 = Formality.validateFieldOnBlurWithoutValidator(state.input.caller_type, state.fieldsStatuses.caller_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: status,
                                  last_name: init.last_name,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$16 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$16,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurLast_nameField */17 :
                  var result$17 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.last_name, validators_last_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: status,
                                  first_name: init.first_name
                                };
                        }));
                  if (result$17 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$17,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFirst_nameField */18 :
                  var result$18 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.first_name, validators_first_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                  partload_customer: init.partload_customer,
                                  registration_status: init.registration_status,
                                  blacklist_reason: init.blacklist_reason,
                                  temporarily_deactivated: init.temporarily_deactivated,
                                  customer_type: init.customer_type,
                                  gst_reg_address: init.gst_reg_address,
                                  gstin: init.gstin,
                                  otp: init.otp,
                                  email: init.email,
                                  unconfirmed_email: init.unconfirmed_email,
                                  geo_region: init.geo_region,
                                  port_gold_status: init.port_gold_status,
                                  company_name: init.company_name,
                                  secondary_mobile: init.secondary_mobile,
                                  mobile: init.mobile,
                                  caller_type: init.caller_type,
                                  last_name: init.last_name,
                                  first_name: status
                                };
                        }));
                  if (result$18 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$18,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */19 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */19,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */20,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */22);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */21);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */20 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */21 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */22 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateSubscribed_for_promo_smsField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.subscribed_for_promo_sms, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: status,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePartload_customerField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.partload_customer, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: status,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateRegistration_statusField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.registration_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateBlacklist_reasonField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.blacklist_reason, state.submissionStatus, validators_blacklist_reason, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: status,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTemporarily_deactivatedField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$4.temporarily_deactivated, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: status,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCustomer_typeField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$5.customer_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: status,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateGst_reg_addressField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.gst_reg_address, state.submissionStatus, validators_gst_reg_address, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: status,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateGstinField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$7, metadata, state.fieldsStatuses.gstin, state.submissionStatus, validators_gstin, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: status,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateOtpField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$8.otp, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: status,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEmailField */9 :
                  var nextInput$9 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$9,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$9.email, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: status,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateUnconfirmed_emailField */10 :
                  var nextInput$10 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$10,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$10, metadata, state.fieldsStatuses.unconfirmed_email, state.submissionStatus, validators_unconfirmed_email, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: status,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateGeo_regionField */11 :
                  var nextInput$11 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$11,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$11, metadata, state.fieldsStatuses.geo_region, state.submissionStatus, validators_geo_region, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: status,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePort_gold_statusField */12 :
                  var nextInput$12 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$12,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$12.port_gold_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCompany_nameField */13 :
                  var nextInput$13 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$13,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$13, metadata, state.fieldsStatuses.company_name, state.submissionStatus, validators_company_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: status,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSecondary_mobileField */14 :
                  var nextInput$14 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$14,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$14, metadata, state.fieldsStatuses.secondary_mobile, state.submissionStatus, validators_secondary_mobile, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: status,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMobileField */15 :
                  var nextInput$15 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$15,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$15.mobile, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: status,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCaller_typeField */16 :
                  var nextInput$16 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$16,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$16.caller_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: status,
                                            last_name: init.last_name,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateLast_nameField */17 :
                  var nextInput$17 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$17,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$17, metadata, state.fieldsStatuses.last_name, state.submissionStatus, validators_last_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: status,
                                            first_name: init.first_name
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFirst_nameField */18 :
                  var nextInput$18 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$18,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$18, metadata, state.fieldsStatuses.first_name, state.submissionStatus, validators_first_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            subscribed_for_promo_sms: init.subscribed_for_promo_sms,
                                            partload_customer: init.partload_customer,
                                            registration_status: init.registration_status,
                                            blacklist_reason: init.blacklist_reason,
                                            temporarily_deactivated: init.temporarily_deactivated,
                                            customer_type: init.customer_type,
                                            gst_reg_address: init.gst_reg_address,
                                            gstin: init.gstin,
                                            otp: init.otp,
                                            email: init.email,
                                            unconfirmed_email: init.unconfirmed_email,
                                            geo_region: init.geo_region,
                                            port_gold_status: init.port_gold_status,
                                            company_name: init.company_name,
                                            secondary_mobile: init.secondary_mobile,
                                            mobile: init.mobile,
                                            caller_type: init.caller_type,
                                            last_name: init.last_name,
                                            first_name: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */19 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */20 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */21 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateSubscribed_for_promo_sms: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSubscribed_for_promo_smsField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePartload_customer: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePartload_customerField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateRegistration_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateRegistration_statusField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateBlacklist_reason: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateBlacklist_reasonField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTemporarily_deactivated: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTemporarily_deactivatedField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCustomer_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCustomer_typeField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateGst_reg_address: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateGst_reg_addressField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateGstin: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateGstinField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateOtp: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateOtpField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEmail: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEmailField */9,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateUnconfirmed_email: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateUnconfirmed_emailField */10,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateGeo_region: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateGeo_regionField */11,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePort_gold_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePort_gold_statusField */12,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCompany_name: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCompany_nameField */13,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSecondary_mobile: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSecondary_mobileField */14,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMobile: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMobileField */15,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCaller_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCaller_typeField */16,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateLast_name: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateLast_nameField */17,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateFirst_name: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFirst_nameField */18,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurSubscribed_for_promo_sms: (function (param) {
              return Curry._1(dispatch, /* BlurSubscribed_for_promo_smsField */0);
            }),
          blurPartload_customer: (function (param) {
              return Curry._1(dispatch, /* BlurPartload_customerField */1);
            }),
          blurRegistration_status: (function (param) {
              return Curry._1(dispatch, /* BlurRegistration_statusField */2);
            }),
          blurBlacklist_reason: (function (param) {
              return Curry._1(dispatch, /* BlurBlacklist_reasonField */3);
            }),
          blurTemporarily_deactivated: (function (param) {
              return Curry._1(dispatch, /* BlurTemporarily_deactivatedField */4);
            }),
          blurCustomer_type: (function (param) {
              return Curry._1(dispatch, /* BlurCustomer_typeField */5);
            }),
          blurGst_reg_address: (function (param) {
              return Curry._1(dispatch, /* BlurGst_reg_addressField */6);
            }),
          blurGstin: (function (param) {
              return Curry._1(dispatch, /* BlurGstinField */7);
            }),
          blurOtp: (function (param) {
              return Curry._1(dispatch, /* BlurOtpField */8);
            }),
          blurEmail: (function (param) {
              return Curry._1(dispatch, /* BlurEmailField */9);
            }),
          blurUnconfirmed_email: (function (param) {
              return Curry._1(dispatch, /* BlurUnconfirmed_emailField */10);
            }),
          blurGeo_region: (function (param) {
              return Curry._1(dispatch, /* BlurGeo_regionField */11);
            }),
          blurPort_gold_status: (function (param) {
              return Curry._1(dispatch, /* BlurPort_gold_statusField */12);
            }),
          blurCompany_name: (function (param) {
              return Curry._1(dispatch, /* BlurCompany_nameField */13);
            }),
          blurSecondary_mobile: (function (param) {
              return Curry._1(dispatch, /* BlurSecondary_mobileField */14);
            }),
          blurMobile: (function (param) {
              return Curry._1(dispatch, /* BlurMobileField */15);
            }),
          blurCaller_type: (function (param) {
              return Curry._1(dispatch, /* BlurCaller_typeField */16);
            }),
          blurLast_name: (function (param) {
              return Curry._1(dispatch, /* BlurLast_nameField */17);
            }),
          blurFirst_name: (function (param) {
              return Curry._1(dispatch, /* BlurFirst_nameField */18);
            }),
          subscribed_for_promo_smsResult: Formality.exposeFieldResult(state.fieldsStatuses.subscribed_for_promo_sms),
          partload_customerResult: Formality.exposeFieldResult(state.fieldsStatuses.partload_customer),
          registration_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.registration_status),
          blacklist_reasonResult: Formality.exposeFieldResult(state.fieldsStatuses.blacklist_reason),
          temporarily_deactivatedResult: Formality.exposeFieldResult(state.fieldsStatuses.temporarily_deactivated),
          customer_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.customer_type),
          gst_reg_addressResult: Formality.exposeFieldResult(state.fieldsStatuses.gst_reg_address),
          gstinResult: Formality.exposeFieldResult(state.fieldsStatuses.gstin),
          otpResult: Formality.exposeFieldResult(state.fieldsStatuses.otp),
          emailResult: Formality.exposeFieldResult(state.fieldsStatuses.email),
          unconfirmed_emailResult: Formality.exposeFieldResult(state.fieldsStatuses.unconfirmed_email),
          geo_regionResult: Formality.exposeFieldResult(state.fieldsStatuses.geo_region),
          port_gold_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.port_gold_status),
          company_nameResult: Formality.exposeFieldResult(state.fieldsStatuses.company_name),
          secondary_mobileResult: Formality.exposeFieldResult(state.fieldsStatuses.secondary_mobile),
          mobileResult: Formality.exposeFieldResult(state.fieldsStatuses.mobile),
          caller_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.caller_type),
          last_nameResult: Formality.exposeFieldResult(state.fieldsStatuses.last_name),
          first_nameResult: Formality.exposeFieldResult(state.fieldsStatuses.first_name),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              var exit = 0;
              if (match.subscribed_for_promo_sms || match.partload_customer || match.registration_status || match.blacklist_reason || match.temporarily_deactivated || match.customer_type || match.gst_reg_address || match.gstin || match.otp || match.email || match.unconfirmed_email || match.geo_region || match.port_gold_status || match.company_name || match.secondary_mobile || match.mobile || match.caller_type || match.last_name) {
                exit = 1;
              } else {
                if (!match.first_name) {
                  return false;
                }
                exit = 1;
              }
              if (exit === 1) {
                var exit$1 = 0;
                exit$1 = 2;
                if (exit$1 === 2) {
                  var exit$2 = 0;
                  exit$2 = 3;
                  if (exit$2 === 3) {
                    var exit$3 = 0;
                    exit$3 = 4;
                    if (exit$3 === 4) {
                      var exit$4 = 0;
                      exit$4 = 5;
                      if (exit$4 === 5) {
                        var exit$5 = 0;
                        exit$5 = 6;
                        if (exit$5 === 6) {
                          var exit$6 = 0;
                          exit$6 = 7;
                          if (exit$6 === 7) {
                            var exit$7 = 0;
                            exit$7 = 8;
                            if (exit$7 === 8) {
                              return true;
                            }
                            
                          }
                          
                        }
                        
                      }
                      
                    }
                    
                  }
                  
                }
                
              }
              
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */19);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */20);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */21);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */21,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */22);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

export {
  Form ,
  
}
/* react Not a pure module */
